export const headerConfig = {
  headerTitle: 'Draft Applications',
  headerDescription: 'List of Draft Applications',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
